export default __webpack_public_path__ + "static/media/temperature-cold.cdd40680.svg";